import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core'
import { FormGroup, Validators, FormBuilder } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { NgZone } from '@angular/core'
import { RegistrationDialogComponent } from 'src/app/shared-module/components/registration-dialog/registration-dialog.component';
import { AuthService } from '../../services/auth.service';
import Swal from 'sweetalert2';
import { RegisterTermsConditionComponent } from '../register-terms-condition/register-terms-condition.component';
import { AdminService } from 'src/app/admin/services/admin.service';
import { PaymentReceiptComponent } from '../payment-receipt/payment-receipt.component';

@Component({
  selector: 'app-reg-common-form',
  templateUrl: './reg-common-form.component.html',
  styleUrls: ['./reg-common-form.component.scss']
})

export class RegCommonFormComponent implements OnInit, OnChanges {
  userInputForm: FormGroup;
  otpBox = [1, 2, 3, 4, 5, 6]
  showOtpInput: boolean = false;
  showVerify: boolean = false;
  isCheckTermsCon: boolean = false;
  // loader:boolean = true;
  @Input() inputDataList: any;
  @Input() showSubmitBtn: boolean = true;
  @Input() showDraftBtn: boolean = false;
  @Input() showCancelBtn: boolean = false;
  @Input() submitBtnText: any = 'SUBMIT';
  @Input() DraftBtnText: any = 'DRAFT'
  @Input() CancelBtnText: any = 'CANCEL';
  @Input() showTermsCondition: boolean = false;
  @Input() formName: any = '';
  @Output() formButtonResEvent = new EventEmitter();
  @Input() heading: { title: string; subTitle: string }[] = [];
  @Input() panelListItem = [];
  @Input() isDisableForm;
  @Input() couponData;
  @Output() couponDetails = new EventEmitter()

  keys: any[];
  otpTxnId: any;
  otp: any;
  showResendOtp: boolean = false;
  resendSecLeft: number = 90;
  showResendOTPEnable: boolean = false;
  // returnedValue: NodeJS.Timeout;
  showtermsDialog: boolean = false;
  facility_owner_mobile: any;
  salutation = ['Mr.', 'Mrs.', 'Ms.', 'Dr.', 'Others']
  queryParams: any;
  isFormDisable: boolean = false;
  realOptionsOBGYN = [
    { name: '< 6 beds', value: 1, id: 1 },
    { name: '6 to 20 beds', value: 2, id: 2 },
    { name: '20 to 50 beds', value: 3, id: 3 },
    { name: '50 to 100 beds', value: 4, id: 4 },
    { name: '100 to 300 Beds', value: 5, id: 5 },
    { name: '>300', value: 6, id: 6 },
  ];
  realOptionsDeliveries = [
    { name: '> 5', value: 1, id: 1 },
    { name: '>5 to <15', value: 2, id: 2 },
    { name: '>15 to <20 ', value: 3, id: 3 },
    { name: '>20 to <50', value: 4, id: 4 },
    { name: '>50', value: 5, id: 5 },
  ]
  appliedCouponId: any;
  totalDiscountedAmount: any;
  paymentStatus: any = 'Pending';
  isSalutationDisable: boolean = false;
  amountPaidTillNow: any = 0;
  pendingAmount: number = 20000;
  totalAmountToPaid: any = 20000;
  isPaymentRejected: boolean = false;
  paymentRejectionReason: any;
  isAdminLogin: boolean = false;
  userData: any;
  isPaymentApprovedRemarks: boolean;
  paymentApprovedRemarks: any;
  userProfileUpdated: boolean = false;
  reffered_cse_name: any;
  paymentDetails: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    public dialog: MatDialog,
    private zone: NgZone,
    private authService: AuthService,
    private adminService: AdminService
  ) {

    this.queryParams = this.route.snapshot.queryParams
    let q = Object.keys(this.queryParams)
    if (q.length > 0) {
      let decodedStr = atob(`${q[0]}`);
      // console.log('qq', decodedStr);
      let properties = decodedStr.split('&');
      let obj = {};
      properties.forEach(function (property) {
        let tup = property.split('=');
        obj[tup[0]] = tup[1];
      });
      this.queryParams = obj;
    }

    // console.log('after decrypted in common', this.queryParams);

    // this.parentChildRelationship();
    // console.log(sessionStorage.getItem("token"));

  }
  ngOnInit(): void {
    // this.openReceiptDialog()

    this.createForm();
    if (this.queryParams?.isDisable) {
      this.userInputForm.disable();
      this.isFormDisable = true;
    }
    this.prefill();
    this.facility_owner_mobile = sessionStorage.getItem("registered number");

    if (this.isFormDisable) {
      this.userInputForm.disable();
    } else if (!this.isFormDisable) {
      this.userInputForm.enable();
    }


    if (this.formName == 'addCSEForm') {
      this.isSalutationDisable = true;
    } else {
      this.isSalutationDisable = false;
    }

    this.isAdminLogin = sessionStorage.getItem('adminLogin') !== null ? sessionStorage.getItem('adminLogin') == 'true' ? true : false : false;

    // if (this.isFormDisable == false && this.formName == 'detailedRegister') {
    // for(let i=0; i<this.inputDataList.length; i++){
    //   for(let j=0; j<this.inputDataList[i].length; j++){
    //     if(this.inputDataList[i][j]?.controllerName == 'ref_cse_id'){
    //       this.inputDataList.pop();
    //       this.heading.pop();
    //     }
    //   }
    // } 
    // if (this.heading.length > 8) {
    //   // delete this.inputDataList[8];
    //   // delete this.heading[8];
    //   this.inputDataList.pop();
    //   this.heading.pop();
    // }

    // }
  }

  prefill() {
    // console.log(this.formName);

    if (this.formName == 'detailedRegister') {
      let facilityUserId = sessionStorage.getItem("userId");
      if (this.router.url.split('?')[0] == '/admin/facility-info') {
        facilityUserId = this.queryParams.userId;
      }
      this.authService.getUserDetail(facilityUserId, sessionStorage.getItem("token")).subscribe((response: any) => {
        this.userData = response?.data;
        let keys = Object.keys(response.data)
        this.reffered_cse_name = response?.data?.ref_cse?.name;
        keys.map((key: any) => {
          if (response.data[key] != null) {
            this.userInputForm.patchValue({
              [key]: response.data[key]
            })
          }

          if (key == 'find_manyata' && response.data[key] == '2') {
            this.inputDataList[2][3].hide = false;
            this.inputDataList[2][3].required = true;
            this.userInputForm.controls["ref_cse_id"].setValidators([Validators.required]);
            this.userInputForm.get('ref_cse_id').updateValueAndValidity();

            this.inputDataList[2][4].hide = true;
            this.inputDataList[2][4].required = false;
            this.userInputForm.get('other').clearValidators();
            this.userInputForm.get('other').updateValueAndValidity();
            this.userInputForm.patchValue({
              'other': ""
            });

          } else if (key == 'find_manyata' && response.data[key] == '5') {
            this.inputDataList[2][4].hide = false;
            this.inputDataList[2][4].required = true;
            this.userInputForm.controls["other"].setValidators([Validators.required]);
            this.userInputForm.get('other').updateValueAndValidity();

            //For CSE Name Field
            this.inputDataList[2][3].hide = true;
            this.inputDataList[2][3].required = false;
            this.userInputForm.controls["ref_cse_id"].clearValidators();
            this.userInputForm.get('ref_cse_id').updateValueAndValidity();

            // this.inputDataList[2][3].hide = true;
            // this.inputDataList[2][3].required = false;
            // this.userInputForm.get('ref_cse_id').clearValidators();
            // this.userInputForm.get('ref_cse_id').updateValueAndValidity();
            this.userInputForm.patchValue({
              'ref_cse_id': ""
            });
          } else if (key == 'find_manyata' && response.data[key] != '2' && response.data[key] != '5') {
            this.inputDataList[2][3].hide = true;
            this.inputDataList[2][3].required = false;
            this.inputDataList[2][4].hide = true;
            this.inputDataList[2][4].required = false;
            this.userInputForm.get('ref_cse_id').clearValidators();
            this.userInputForm.get('ref_cse_id').updateValueAndValidity();
            this.userInputForm.get('other').clearValidators();
            this.userInputForm.get('other').updateValueAndValidity();
            this.userInputForm.patchValue({
              'ref_cse_id': "",
              'other': ""
            });
          } else if (key == 'is_hospital_reg_nhp' && response.data[key] == '1') {
            this.inputDataList[3][2].hide = false;
            this.inputDataList[3][2].required = true;
            this.userInputForm.controls["nhp_id"].setValidators([Validators.required]);
            this.userInputForm.get('nhp_id').updateValueAndValidity();
          } else if (key == 'is_hospital_reg_nhp' && response.data[key] == '2') {
            this.inputDataList[3][2].hide = true;
            this.inputDataList[3][2].required = false;
            this.userInputForm.get('nhp_id').clearValidators();
            this.userInputForm.get('nhp_id').updateValueAndValidity();
            this.userInputForm.patchValue({
              'nhp_id': ""
            });
          } else if (key == 'other_accred_certificate' && response.data[key] == '1') {
            this.inputDataList[6][3].hide = false;
            this.inputDataList[6][3].required = true;
            this.userInputForm.controls["specify_accred_certificate"].setValidators([Validators.required]);
            this.userInputForm.get('specify_accred_certificate').updateValueAndValidity();
          } else if (key == 'other_accred_certificate' && response.data[key] == '2') {
            this.inputDataList[6][3].hide = true;
            this.inputDataList[6][3].required = false;
            this.userInputForm.get('specify_accred_certificate').clearValidators();
            this.userInputForm.get('specify_accred_certificate').updateValueAndValidity();
            this.userInputForm.patchValue({
              'specify_accred_certificate': ""
            });
          } else if (key == 'know_similar_hosp_network' && response.data[key] == '1') {
            this.inputDataList[7][1].hide = false;
            this.inputDataList[7][1].required = true;
            this.userInputForm.controls["can_we_contact"].setValidators([Validators.required]);
            this.userInputForm.get('can_we_contact').updateValueAndValidity();
          } else if (key == 'know_similar_hosp_network' && response.data[key] == '2') {
            this.inputDataList[7][1].hide = true;
            this.inputDataList[7][1].required = false;
            this.userInputForm.get('can_we_contact').clearValidators();
            this.userInputForm.get('can_we_contact').updateValueAndValidity();
            this.userInputForm.patchValue({
              'can_we_contact': ""
            });
          }

          if (key == 'facility_owner_mobile') {
            this.facility_owner_mobile = response.data[key];
          }

          if (key == 'is_profile_updated') {
            sessionStorage.setItem('is_profile_updated', response.data[key]);
          }
        })

        if (response?.data?.coupon !== null || response?.data?.is_any_payment_approved) {
          this.couponDetails.emit({ coupon: response?.data?.coupon, is_any_payment_approved: response?.data?.is_any_payment_approved });
        }



        if (response?.data?.payments !== null && response?.data?.payments.length != 0) {
          this.totalAmountToPaid = response?.data?.payments[0]?.total_amount !== null ? response?.data?.payments[0]?.total_amount : 20000;
          this.pendingAmount = response?.data?.payments[0]?.total_amount - response?.data?.total_paid_amount;
          this.amountPaidTillNow = response?.data?.total_paid_amount !== null ? response?.data?.total_paid_amount : 0;

          this.paymentDetails = response?.data?.payments;
          // if (this.pendingAmount == 0) {
          //   this.paymentStatus = 'Completed';
          // } else {
          //   this.paymentStatus = 'Pending';
          // }

          if (response?.data?.payments?.payment_rejected_reason) {
            this.isPaymentRejected = true;
            this.paymentRejectionReason = response?.data?.payments?.payment_rejected_reason;
          }
          if (response?.data?.payments?.remarks) {
            this.isPaymentApprovedRemarks = true;
            this.paymentApprovedRemarks = response?.data?.payments?.remarks;
          }
        }

        if (response?.data?.payments == null && response?.data?.coupon !== null) {
          this.totalAmountToPaid = this.totalAmountToPaid - response?.data?.coupon?.discount;
          this.pendingAmount = this.totalAmountToPaid;
        }

        if (response?.data?.is_payment) {            // All Payment done/No Balance
          this.paymentStatus = 'Completed';
        } else if (response?.data?.overall_payment_status == '1') {    //Payment paid but pending for approval from Admin
          this.paymentStatus = 'Pending For Approval';
        } else if (response?.data?.is_payment == false && response?.data?.overall_payment_status == '2') {  //Some payment done and approved
          this.paymentStatus = 'Partially Completed';
        } else if (response?.data?.is_payment == false && response?.data?.overall_payment_status == '3') {  //Payment Rejected
          this.paymentStatus = 'Rejected';
        } else {
          this.paymentStatus = 'Pending';             //No Payment paid or approved
        }

        if (response?.data?.is_profile_updated == true) {
          this.userProfileUpdated = true;
        }

      })
      // console.log('userInputForm',this.userInputForm);
    }

    if (this.formName == 'addCSEForm' && this.queryParams.userId !== undefined) {
      let userId = sessionStorage.getItem("userId");
      if (this.router.url.split('?')[0] == '/admin/add-cse-form') {
        userId = this.queryParams.userId;
      }
      let params = `id=${userId}`
      this.adminService.getCSEListing(params, sessionStorage.getItem("token")).subscribe((response: any) => {
        console.log(response);
        let keys = Object.keys(response?.data[0]);
        console.log(keys);

        keys.map((key: any) => {
          if (response.data[0][key] != null) {
            this.userInputForm.patchValue({
              [key]: response.data[0][key]
            })
          }
        })
        // console.log(this.userInputForm);
      })
    }
  }

  // parentChildRelationship() {
  //   this.inputDataList.map((array) => {
  //     array.map((obj) => {
  //       // this.keys.push(obj.controllerName)
  //       if (obj.hasOwnProperty('parent')) {
  //         obj.parent['parentName']
  //       }
  //     })
  //   })
  // }

  createForm() {
    let formGroupObj = {}
    this.keys = [];
    this.inputDataList.map((array) => {
      array.map((obj) => {
        this.keys.push(obj.controllerName)
      })
    })

    this.inputDataList.map((array) => {
      array.map((obj) => {
        // console.log('kkk', obj);
        // if (obj.hide == false) {
        if (obj.required) {
          if (obj.type == 'email') {
            formGroupObj[obj.controllerName] = ["", [Validators.required, Validators.email]];
          } else if (obj.controllerName == 'mobile' || obj.controllerName == 'facility_owner_mobile') {
            formGroupObj[obj.controllerName] = ["", [Validators.required, Validators.minLength(10), Validators.maxLength(10)]];
          } else if (obj.controllerName == 'pincode') {
            formGroupObj[obj.controllerName] = ["", [Validators.required, Validators.minLength(6), Validators.maxLength(6)]];
          } else if (obj.controllerName == 'address') {
            formGroupObj[obj.controllerName] = ["", [Validators.required, Validators.maxLength(100)]];
          } else if (obj.valueType == 'text') {                                      // Valuetype text means only able to enter Alphabets
            formGroupObj[obj.controllerName] = ["", [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]];
          } else {
            formGroupObj[obj.controllerName] = ["", Validators.required];
          }
        } else {
          if (obj.type == 'email') {
            formGroupObj[obj.controllerName] = ["", [Validators.email]];
          } else if (obj.controllerName == 'mobile') {
            formGroupObj[obj.controllerName] = ["", [Validators.minLength(10), Validators.maxLength(10)]];
          }
          //  else if (obj.controllerName == 'hospital_reg_num') {
          //   formGroupObj[obj.controllerName] = ["", Validators.minLength(6)];
          // }
           else if (obj.valueType == 'text') {                                     // Valuetype text means only able to enter Alphabets
            formGroupObj[obj.controllerName] = ["", [Validators.pattern('^[a-zA-Z ]*$')]];
          } else {
            formGroupObj[obj.controllerName] = [""];
          }
        }
      })
    }
    )
    if (this.formName == 'detailedRegister') {
      formGroupObj["facility_salutation"] = ["", Validators.required];
      formGroupObj["is_poc_email_check"] = [""];
      formGroupObj["is_mobile_check"] = [""];
    }

    if (this.formName == 'addCSEForm') {
      formGroupObj["facility_salutation"] = ["Dr."];     // For Salutation in Add CSE Form
    }

    console.log('formGroupObj', formGroupObj);
    this.userInputForm = this.formBuilder.group(formGroupObj);
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("regCommon SimpleChanges", changes);
    if (changes.inputDataList && changes.inputDataList.currentValue) {
      // console.log("Input data list call")
      this.inputDataList = changes.inputDataList.currentValue
    }

    if (changes?.panelListItem?.currentValue) {
      this.focusOnCard(changes.panelListItem.currentValue[0]);
    }

    if (changes?.couponData?.currentValue) {
      console.log('inside common couponData', changes?.couponData?.currentValue);
      if (changes?.couponData?.currentValue?.couponId == 'empty') {
        this.appliedCouponId = null;            //Null to empty/reset coupon
        this.totalAmountToPaid = 20000;
        this.pendingAmount = this.totalAmountToPaid;
      } else {
        this.appliedCouponId = changes?.couponData?.currentValue?.couponId;
      }

      if (changes?.couponData?.currentValue?.couponDiscount != undefined) {
        this.totalDiscountedAmount = changes?.couponData?.currentValue?.couponDiscount;
        this.totalAmountToPaid = this.totalAmountToPaid - this.totalDiscountedAmount;
        this.pendingAmount = this.totalAmountToPaid;
      }

    }

    if (this.formName == 'detailedRegister') {
      if (changes?.isDisableForm?.currentValue == true) {
        this.isFormDisable = true;
        // this.userInputForm.disable();
      } else if (changes.isDisableForm?.currentValue == false) {
        if (this.userInputForm.disabled || this.isFormDisable) {
          this.isFormDisable = false;
          this.userInputForm.enable();

          // if (this.heading.length > 8) {
          //   // delete this.inputDataList[8];
          //   // delete this.heading[8];
          //   this.inputDataList.pop();
          //   this.heading.pop();
          // }
          // for(let i=0; i<this.inputDataList.length; i++){
          //   for(let j=0; j<this.inputDataList[i].length; j++){
          //     if(this.inputDataList[i][j].controllerName == 'ref_cse_id'){
          //       this.inputDataList.pop();
          //       this.heading.pop();
          //     }
          //   }
          // }    // To hide Purchase Information Card
          // To hide Purchase Information Card
        }
      }

      if (changes?.showDraftBtn?.currentValue) {
        this.showDraftBtn = changes.showDraftBtn.currentValue == 'true' ? true : false;
        // console.log(this.showDraftBtn);
      }
    }
  }

  focusOnCard(receivedId) {
    // console.log(receivedId);
    (<HTMLInputElement>document.getElementById(receivedId.toString())).scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
  }

  otpInput(event) {
    // console.log('ootp input called', event.key);

    // console.log(event.target.value);
    if (event.target.value.length > 1) {
      (<HTMLInputElement>document.getElementById(event.target.id)).value = event.target.value.slice(-1);
    }

    let id = +event.target.id
    let inputValue = event.data;
    // document.getElementById(id+1).focus()
    if (event.data !== null) {
      id = id !== 6 ? id + 1 : id;
    } else {
      id = id !== 1 ? id - 1 : id;
    }
    document.getElementById((id).toString()).focus();

    let otpVal = '';
    this.otpBox.map((item) => {
      otpVal += (<HTMLInputElement>document.getElementById(item.toString())).value
    })

    console.log('otpVal', +otpVal);

    this.userInputForm.patchValue(
      {
        'otp': otpVal
      }
    )
  }

  checkInput(event, sectionData) {

    if (sectionData.controllerName == 'facility_owner_mobile') {
      // console.log(sectionData.controllerName, event.target.value);
      this.facility_owner_mobile = event.target.value;
    }

    if (event.target.type == 'email') {
      if (this.formName == 'facilityRegister') {
        if (this.userInputForm.controls.email.status == 'VALID') {
          if (this.showResendOtp == false) {
            this.showVerify = true;
            this.showResendOTPEnable = false;
            this.showOtpInput = false;
          }
        } else {
          this.showVerify = false;
          this.showResendOTPEnable = false;
          this.showResendOTPEnable = false;
        }

        if (this.showResendOtp == true) {
          this.showVerify = true;
          this.showOtpInput = false;
          this.showResendOtp = false;
          this.showResendOTPEnable = false;
          this.userInputForm.patchValue(
            {
              'otp': ''
            }
          )
          this.otpBox.map((item) => {
            (<HTMLInputElement>document.getElementById(item.toString())).value = '';
          })
        }
      }
    }
    else if (this.userInputForm.controls.pincode.status == 'VALID') {
      // console.log('its valid now', this.userInputForm.value.pincode);
      if (sectionData.controllerName == 'pincode') {
        this.authService.pinCodeList(this.userInputForm.value.pincode).subscribe((response: any) => {
          // console.log("Pincode List", response[0].PostOffice[0]);
          if (response[0].Message == "No records found") {
            Swal.fire('Error', 'Please enter a valid pincode', 'error');
            this.userInputForm.patchValue({
              'pincode': ""
            })
            // return
          }
          let responseObj = response[0].PostOffice[0];
          // console.log('responseObj', responseObj);
          this.userInputForm.patchValue({
            'state_name': responseObj.State
          })

          this.userInputForm.patchValue({
            'district_name': responseObj.District
          })

          this.userInputForm.patchValue({
            'block_name': responseObj.Block
          })


        },
          (error) => {
            Swal.fire('Error', `${error.error.message}`, 'error')
          }
        )
      }
    } else if (this.userInputForm.controls.pincode.status !== 'VALID') {
      this.userInputForm.patchValue({
        'state_name': ''
      })

      this.userInputForm.patchValue({
        'district_name': ''
      })

      this.userInputForm.patchValue({
        'block_name': ''
      })
    }

    // if (this.userInputForm.status == 'VALID') {
    //   this.formValid = true;
    // }
  }

  checkTermsCons() {
    var checkBox = (<HTMLInputElement>document.getElementById("termsCondition"));
    if (checkBox.checked == true) {
      this.userInputForm.patchValue({
        'tnc': true
      })
    } else {
      this.userInputForm.patchValue({
        'tnc': ''
      })
    }

  }

  getErrorMessage(sectionData: any) {
    if (this.userInputForm.controls[sectionData.controllerName].status == 'INVALID') {
      if (this.userInputForm.controls[sectionData.controllerName].errors?.required) {
        return 'This Field Is Mandatory To Fill';
      }

      return `Please Enter a valid ${sectionData.errorMsg}`;

    }
    return `Please Enter ${sectionData.errorMsg}`;
  }

  submitForm() {

    if (this.userInputForm.status == 'VALID') {
      if (this.userInputForm.value['ref_cse_id'] == "") {
        this.userInputForm.value['ref_cse_id'] = null;
      }
      let resObj = [{ ...this.userInputForm, coupon_id: this.appliedCouponId }, { otpTxnId: this.otpTxnId }]
      this.formButtonResEvent.emit(resObj);
    }

    if (!this.userInputForm.valid) {
      this.userInputForm.markAllAsTouched();
      let invalidFields = [].slice.call(document.getElementsByClassName('ng-invalid'));
      // console.log('invalidFields', invalidFields);

      invalidFields[1].scrollIntoView();
    }

    console.log('submitted', this.userInputForm);
  }

  draftForm() {
    console.log("Draft", this.userInputForm);
    if (this.DraftBtnText !== 'PREVIOUS') {
      for (const key in this.userInputForm.controls) {
        this.userInputForm.get(key).clearValidators();
        this.userInputForm.get(key).updateValueAndValidity();
      }

      // if (this.userInputForm.value?.facility_owner_mobile == null) {
      //   this.userInputForm.patchValue({
      //     "facility_owner_mobile": ""
      //   })
      // }

      let keys = Object.keys(this.userInputForm.value);

      keys.map((key) => {
        if (this.userInputForm.value[key] == null) {
          this.userInputForm.value[key] = "";
        }

        if (key == 'ref_cse_id' && this.userInputForm.value[key] == "") {
          this.userInputForm.value[key] = null;
        }
      })

      let token = sessionStorage.getItem("token")
      // let payload = { ...this.userInputForm.value, finalSubmit: true }    //Temporary adding final submit to bahave as submit (current requirement)
      let payload = { ...this.userInputForm.value, coupon_id: this.appliedCouponId }
      this.authService.detailRegisterSubmit(payload, token).subscribe((response: any) => {

        sessionStorage.setItem("facility name", this.userInputForm.value.facility_name);    //To update name
        Swal.fire("Success", "Data Drafted Successfully", 'success').then(() => {
          // this.ngOnInit();                //Temporary comment
          this.router.navigateByUrl('welcome-login');
        });
      },
        (error) => {
          Swal.fire("Error", `${error.error.message}`, 'error')
        })
    }



    if (this.DraftBtnText == 'PREVIOUS') {
      this.location.back();
      return;
    }
  }

  cancelForm() {
    this.userInputForm.reset();
    this.location.back();
  }

  emailVerifyClick() {
    // let auth = `email = ${ this.userInputForm.value.email }& facility_name=${ this.userInputForm.value.facilityName } `;
    let authObj = {
      email: this.userInputForm.value.email,
      facility_name: this.userInputForm.value.facilityName
    }
    this.userInputForm.patchValue(        // TO empty the value if Verify/Resend click
      {
        'otp': ''
      }
    )
    // this.otpBox.map((item) => {
    //   (<HTMLInputElement>document.getElementById(item.toString())).value = '5';        // TO empty the value if Verify/Resend click
    // })

    this.authService.sendOtp(authObj).subscribe((Data: any) => {
      // console.log("OTP DATA", Data);
      this.otpTxnId = Data.data.otpTxnId;

      this.showVerify = false;
      this.showOtpInput = true
      this.showResendOtp = false;
      this.showResendOTPEnable = true;

      // setTimeout(() => {
      //   this.showResendOtp = true;
      // }, 5000);
      this.resendSecLeft = 90;
      let timer = setInterval(() => {
        if (this.resendSecLeft <= 0) {
          this.showResendOTPEnable = false;
          if (this.showVerify == false) {
            this.showResendOtp = true;
          }
          this.resendSecLeft = 90;
          clearInterval(timer);
        }
        if (this.resendSecLeft > 0) {
          this.resendSecLeft = this.resendSecLeft - 1;

        }
        // console.log(this.resendSecLeft);
      }, 1000)

      // console.log('returnedValue', myInterval);

      // Swal.fire('Success', 'Otp Send Sucessfully! Please check your email', 'success')
      // }
    },
      (error) => {
        // console.log(error.error.message);
        Swal.fire('Error', `${error.error.message} `, 'error')
      }
    )
  }

  selectChange(controllerName, controlValue) {
    console.log('event', controllerName, controlValue);
    if (controllerName == 'find_manyata' && controlValue == '2') {
      this.inputDataList[2][3].hide = false;
      this.inputDataList[2][3].required = true;
      this.userInputForm.controls["ref_cse_id"].setValidators([Validators.required]);
      this.userInputForm.get('ref_cse_id').updateValueAndValidity();
      this.userInputForm.get('ref_cse_id').markAsUntouched();

      this.inputDataList[2][4].hide = true;
      this.inputDataList[2][4].required = false;
      this.userInputForm.get('other').clearValidators();
      this.userInputForm.get('other').updateValueAndValidity();
      this.userInputForm.patchValue({
        'other': ""
      });

    } else if (controllerName == 'find_manyata' && controlValue == '5') {
      this.inputDataList[2][4].hide = false;
      this.inputDataList[2][4].required = true;
      this.userInputForm.controls["other"].setValidators([Validators.required]);
      this.userInputForm.get('other').updateValueAndValidity();
      this.userInputForm.get('other').markAsUntouched();

      this.inputDataList[2][3].hide = true;
      this.inputDataList[2][3].required = false;
      this.userInputForm.get('ref_cse_id').clearValidators();
      this.userInputForm.get('ref_cse_id').updateValueAndValidity();
      this.userInputForm.patchValue({
        'ref_cse_id': ""
      });
    } else if (controllerName == 'find_manyata' && controlValue != '2' && controlValue != '5') {
      this.inputDataList[2][3].hide = true;
      this.inputDataList[2][3].required = false;
      this.inputDataList[2][4].hide = true;
      this.inputDataList[2][4].required = false;
      this.userInputForm.get('ref_cse_id').clearValidators();
      this.userInputForm.get('ref_cse_id').updateValueAndValidity();
      this.userInputForm.get('other').clearValidators();
      this.userInputForm.get('other').updateValueAndValidity();
      this.userInputForm.patchValue({
        'ref_cse_id': "",
        'other': ""
      });
    }

    if (controllerName == 'num_bed_facility') {
      let arrOBGYN = [];
      // let arrDelivery = [];
      if (controlValue == 1) {
        arrOBGYN = this.realOptionsOBGYN.filter((item) => item.id == 1)
        // arrDelivery = this.realOptionsDeliveries.filter((item) => item.id == 1)
      } else if (controlValue > 1) {
        arrOBGYN = this.realOptionsOBGYN.filter((item) => item.id <= controlValue);
        // arrDelivery = this.realOptionsDeliveries.filter((item) => item.id <= controlValue)
      }

      this.userInputForm.patchValue({
        num_obgyn_bed: "",
      });
      this.userInputForm.get('num_obgyn_bed').markAsUntouched();

      this.inputDataList[3][4].option = arrOBGYN;
      // this.inputDataList[3][5].option = arrDelivery;
      this.inputDataList[3][4].isDisable = false;
      // this.inputDataList[3][5].isDisable = false;
    }
  }

  changeRadio(controllerName, value) {
    console.log(controllerName, value);
    if (controllerName == 'is_hospital_reg_nhp' && value == '1') {
      this.inputDataList[3][2].hide = false;
      this.inputDataList[3][2].required = true;
      this.userInputForm.controls["nhp_id"].setValidators([Validators.required]);
      this.userInputForm.get('nhp_id').updateValueAndValidity();
      this.userInputForm.get('nhp_id').markAsUntouched();
    } else if (controllerName == 'is_hospital_reg_nhp' && value == '2') {
      this.inputDataList[3][2].hide = true;
      this.inputDataList[3][2].required = false;
      this.userInputForm.get('nhp_id').clearValidators();
      this.userInputForm.get('nhp_id').updateValueAndValidity();
      this.userInputForm.patchValue({
        'nhp_id': ""
      });
    } else if (controllerName == 'other_accred_certificate' && value == '1') {
      this.inputDataList[6][3].hide = false;
      this.inputDataList[6][3].required = true;
      this.userInputForm.controls["specify_accred_certificate"].setValidators([Validators.required]);
      this.userInputForm.get('specify_accred_certificate').updateValueAndValidity();
      this.userInputForm.get('specify_accred_certificate').markAsUntouched();
    } else if (controllerName == 'other_accred_certificate' && value == '2') {
      this.inputDataList[6][3].hide = true;
      this.inputDataList[6][3].required = false;
      this.userInputForm.get('specify_accred_certificate').clearValidators();
      this.userInputForm.get('specify_accred_certificate').updateValueAndValidity();
      this.userInputForm.patchValue({
        'specify_accred_certificate': ""
      });
    } else if (controllerName == 'know_similar_hosp_network' && value == '1') {
      this.inputDataList[7][1].hide = false;
      this.inputDataList[7][1].required = true;
      this.userInputForm.controls["can_we_contact"].setValidators([Validators.required]);
      this.userInputForm.get('can_we_contact').updateValueAndValidity();
      this.userInputForm.get('can_we_contact').markAsUntouched();
    } else if (controllerName == 'know_similar_hosp_network' && value == '2') {
      // console.log(this.inputDataList[7][1]);

      this.inputDataList[7][1].hide = true;
      this.inputDataList[7][1].required = false;
      this.userInputForm.get('can_we_contact').clearValidators();
      this.userInputForm.get('can_we_contact').updateValueAndValidity();
      this.userInputForm.patchValue({
        'can_we_contact': ""
      });
    }

  }

  openDialog() {
    const dialogRef = this.dialog.open(RegisterTermsConditionComponent, {
      width: '500px',
      // backdropClass: 'backdropBackground',
    });
  }

  openTermsConditionDialog() {
    // this.showtermsDialog = true;
    this.openDialog()
  }

  handlePaste() {
    console.log('inside paste');
    navigator.clipboard.readText()
      .then(copiedText => {
        console.log('copiedText', copiedText);

        let numLength = copiedText.length

        let otpVal = '';
        for (let i = 1; i <= numLength; i++) {
          console.log(copiedText.substring(i, i + 1));
          (<HTMLInputElement>document.getElementById(i.toString())).value = copiedText.substring(i - 1, i);
          otpVal += copiedText.substring(i - 1, i);
        }
        (<HTMLInputElement>document.getElementById("6")).focus();
        this.userInputForm.patchValue(
          {
            'otp': otpVal
          }
        )
      })
      .catch(err => {
        Swal.fire('Error', 'Clipboard Empty', 'error')
      });
  }

  handleCheckPrevious(checkBoxId, controllerName) {
    console.log(checkBoxId, controllerName);
    if ((<HTMLInputElement>document.getElementById(checkBoxId)).checked) {
      if (controllerName == 'email_user_manyata') {
        this.userInputForm.patchValue({
          'email_user_manyata': sessionStorage.getItem("login email")
        });
        this.inputDataList.map((array, i) => {
          array.map((obj, j) => {
            if (obj.controllerName == 'email_user_manyata') {
              this.inputDataList[i][j].isDisable = true;
            }
          })
        })

        this.userInputForm.patchValue({
          'is_poc_email_check': true
        });
        // (<HTMLInputElement>document.getElementById(inputFieldId)).style.cursor = 'not-allowed';
        // (<HTMLInputElement>document.getElementById(inputFieldId)).style.pointerEvents = 'none';
        // (<HTMLInputElement>document.getElementById(inputFieldId)).style.background = 'gray';

      } else if (controllerName == 'mobile') {
        this.userInputForm.patchValue({
          'mobile': this.facility_owner_mobile
        });
        this.inputDataList.map((array, i) => {
          array.map((obj, j) => {
            if (obj.controllerName == 'mobile') {
              this.inputDataList[i][j].isDisable = true;
            }
          })
        })

        this.userInputForm.patchValue({
          'is_mobile_check': true
        });
        // (<HTMLInputElement>document.getElementById(inputFieldId)).style.pointerEvents = 'none';
      }
    } else {
      if (controllerName == 'email_user_manyata') {
        this.userInputForm.patchValue({
          'email_user_manyata': ''
        });
        this.inputDataList.map((array, i) => {
          array.map((obj, j) => {
            if (obj.controllerName == 'email_user_manyata') {
              this.inputDataList[i][j].isDisable = false;
            }
          })
        })

        this.userInputForm.patchValue({
          'is_poc_email_check': false
        });
        // (<HTMLInputElement>document.getElementById(inputFieldId)).style.pointerEvents = 'auto';
      } else if (controllerName == 'mobile') {
        this.userInputForm.patchValue({
          'mobile': ""
        });

        this.inputDataList.map((array, i) => {
          array.map((obj, j) => {
            if (obj.controllerName == 'mobile') {
              this.inputDataList[i][j].isDisable = false;
            }
          })
        })

        this.userInputForm.patchValue({
          'is_mobile_check': false
        });

        // (<HTMLInputElement>document.getElementById(inputFieldId)).style.pointerEvents = 'auto';
      }

      // if (controllerName == 'email_user_manyata') {
      //   this.userInputForm.patchValue({
      //     'email_user_manyata': sessionStorage.getItem("login email")
      //   })
      // } else if (controllerName == 'mobile') {
      //   if (sessionStorage.getItem("login contact number") != undefined) {
      //     this.userInputForm.patchValue({
      //       'mobile': sessionStorage.getItem("login contact number")
      //     });
      //   } else if (sessionStorage.getItem("login contact number") == undefined) {
      //     Swal.fire("Error", 'No record found', 'error')
      //   }

      //   // console.log(sessionStorage.getItem("logined contact number"));

      // }
    }
  }

  salutationChange(value) {
    console.log(value);

    // this.userInputForm.patchValue({
    //   'facility_salutation': value
    // })
  }

  // backIconClick() {
  //   this.location.back();
  // }

  payLaterClick() {
    this.router.navigateByUrl('/welcome-login')
  }

  makePayment() {
    if (this.userInputForm.value['ref_cse_id'] == "") {
      this.userInputForm.value['ref_cse_id'] = null;
    }
    let payload = { ...this.userInputForm.value, coupon_id: this.appliedCouponId, finalSubmit: true };
    let token = sessionStorage.getItem("token");
    this.authService.detailRegisterSubmit(payload, token).subscribe((response: any) => {
      this.router.navigateByUrl('login/payment');
    },
      (error) => {
        Swal.fire('Error', `${error.error.message}`, 'error')
      }
    )
  }

  openReceiptDialog(paymentData) {
    const dialogRef = this.dialog.open(PaymentReceiptComponent, {
      width: '600px',
      data: [this.userData, paymentData],
    });

    // dialogRef.afterClosed().subscribe(() => window.location.reload());
  }
}
